import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { DestinatarioVO } from "./destinatarioVO";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";

export class FormDestinatariVO {
  destinatari: DestinatarioVO[] = new Array<DestinatarioVO>();
  tipoPartenzaHidden: TipoSupportoDocumentoEnum;
}